import React, { Component } from 'react';

import _ from 'lodash';

import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import Tooltip from '@material-ui/core/Tooltip';

import ConfirmButton from '../../components/ConfirmButton';

import validator from '../../helpers/validator';

import classes from './AgentNetworkPanel.module.css';

export default class ConfigureAgentPanel extends Component {
    state = {
        formIsValid:  false,
        formControls: {
            databaseServer: {
                value:       '',
                placeholder: 'Database Server Address',
                valid:       false,
                touched:     false,
                message:     ''
            },
            databaseName: {
                value:           '',
                placeholder:     'Signature Database',
                valid:           false,
                touched:         false,
                message:         '',
                validationRules: {
                    isRequired: true
                }
            },
            databaseUser: {
                value:       '',
                placeholder: 'Username',
                valid:       false,
                touched:     false,
                message:     '',
            },
            databasePassword: {
                value:       '',
                placeholder: 'Password',
                valid:       false,
                touched:     false,
                message:     '',
            },
            batchPollTime: {
                value:           50,
                placeholder:     'Batch Poll Time (ms)',
                valid:           true,
                touched:         false,
                message:         '',
                validationRules: {
                    isNumeric: true
                }
            },
            batchReadSize: {
                value:           100,
                placeholder:     'Batch Read Size',
                valid:           true,
                touched:         false,
                message:         '',
                validationRules: {
                    isNumeric: true
                }
            }
        }
    }

    componentDidMount() {
        const { agent } = this.props;

        if (agent) {

            const updatedControls = {...this.state.formControls};
            updatedControls.databaseServer.value = _.get(agent, 'databaseServer', '');
            updatedControls.databaseUser.value = _.get(agent, 'databaseUser', '');
            updatedControls.databaseName.value = _.get(agent, 'databaseName', '');
            updatedControls.batchPollTime.value = _.get(agent, 'batchPollTime', 50);
            updatedControls.batchReadSize.value = _.get(agent, 'batchReadSize', 100);

            _.forEach(updatedControls, (value, key) => {

                if (key === 'databaseUser' ||
                    key === 'databasePassword' ||
                    key === 'databaseName') {
                    updatedControls[key].valid = true;
                    updatedControls[key].touched = true;
                    return;
                }

                if (!_.isNil(updatedControls[key]) &&
                    updatedControls[key].value !== '') {
                    updatedControls[key].valid = true;
                    updatedControls[key].touched = true;
                }
            });

            this.setState({
                formControls: updatedControls
            });
        }
    }

    updateControls = (update, event) => {
        const { name } = event.target;
        const updatedControls = { ...this.state.formControls };

        updatedControls[name].value = update;

        this.setState({
            formControls: updatedControls
        });
    }

    showTooltipMessage = formState => {
        return formState ? `Click to Save settings.` : `You must check 'This is a device I trust' checkbox to save.`;
    }

    handleValidation = event => {
        const validatedState = validator(this.state, event);

        this.setState({
            formControls: validatedState.updatedControls,
            formIsValid:  validatedState.formIsValid
        });
    }

    handleChange = event => {
        const { value } = event.target;

        this.updateControls(value, event);
    }

    handleCheckbox = event => {
        const { checked } = event.target;

        this.updateControls(checked, event);
    }

    handleSave = () => {
        const { save, agent } = this.props;
        const { formControls } = this.state;
        const payload = {
            name:             agent.name,
            id:               agent.id,
            databasePassword: formControls.databasePassword.value,
            databaseServer:   formControls.databaseServer.value,
            databaseName:     formControls.databaseName.value,
            databaseUser:     formControls.databaseUser.value
        };
        save(payload);
    }

    render() {
        const { isLoading} = this.props;

        return (
            <div className={classes.NetworkPanel}>
                <div className={classes.formContainer}>
                    <div className={classes.formColumn}>
                        <div className={classes.labelColumn}>
                            <div>
                                <div className={classes.labelHeader}>
                                    <img src="/assets/images/generalNetworkSettingsIconColor.svg" alt="settings icon" />
                                    <span>Signature Login Information</span>
                                </div>
                                <div className={classes.labelContent}>
                                    <p>
                                        Please provide the Microsoft SQL Server Name\Instance or IP address for your Dynamics GP database instance (ex. DYNAMICS), username and password.
                                    </p>
                                    <p>
                                        Please do not use the “sa” login. We recommend creating a user that has only the permissions required. Please see the BOB documentation for details about the permissions required for the FSM Integration.
                                    </p>
                                </div>
                            </div>
                            <div>
                                <div className={classes.labelHeader}>
                                    <img src="/assets/images/lockFlatOutline.svg" alt="credentials icon" />
                                    <span>Signature Database</span>
                                </div>
                                <div className={classes.labelContent}>
                                    <p>
                                        Please provide the Microsoft SQL Server company database name that aligns with the related Dynamics GP Company in use (ex. FABRIKAM).
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className={classes.inputColumn}>
                            <div className={`${classes.inputs} ${classes.topNiagaraInputGroup}`}>
                                <FormControl className={classes.inputWrapper}>
                                    <InputLabel
                                        htmlFor="databaseServer"
                                        classes={{
                                            focused: classes.cssFocused
                                        }}
                                    >
                                        {this.state.formControls.databaseServer.placeholder}
                                    </InputLabel>
                                    <Input
                                        id="databaseServer"
                                        name="databaseServer"
                                        value={this.state.formControls.databaseServer.value}
                                        onChange={this.handleChange}
                                        classes={{
                                            underline: classes.cssUnderline
                                        }}
                                        inputProps={{
                                            onBlur: this.handleValidation
                                        }}
                                    />
                                    {!this.state.formControls.databaseServer.valid &&
                                      this.state.formControls.databaseServer.touched && <FormHelperText className={classes.error}>{this.state.formControls.databaseServer.message}</FormHelperText>}
                                </FormControl>
                                <FormControl className={classes.inputWrapper}>
                                    <InputLabel
                                        htmlFor="databaseUser"
                                        classes={{
                                            focused: classes.cssFocused
                                        }}
                                    >
                                        {this.state.formControls.databaseUser.placeholder}
                                    </InputLabel>
                                    <Input
                                        id="databaseUser"
                                        name="databaseUser"
                                        value={this.state.formControls.databaseUser.value}
                                        onChange={this.handleChange}
                                        classes={{
                                            underline: classes.cssUnderline
                                        }}
                                        inputProps={{
                                            onBlur: this.handleValidation
                                        }}
                                    />
                                    {!this.state.formControls.databaseUser.valid &&
                                      this.state.formControls.databaseUser.touched && <FormHelperText className={classes.error}>{this.state.formControls.databaseUsername.message}</FormHelperText>}
                                </FormControl>
                                <FormControl className={classes.inputWrapper}>
                                    <InputLabel
                                        htmlFor="databasePassword"
                                        classes={{
                                            focused: classes.cssFocused
                                        }}
                                    >
                                        {this.state.formControls.databasePassword.placeholder}
                                    </InputLabel>
                                    <Input
                                        id="databasePassword"
                                        name="databasePassword"
                                        type="password"
                                        value={this.state.formControls.databasePassword.value}
                                        onChange={this.handleChange}
                                        classes={{
                                            underline: classes.cssUnderline
                                        }}
                                        inputProps={{
                                            onBlur: this.handleValidation
                                        }}
                                    />
                                    {!this.state.formControls.databasePassword.valid &&
                                      this.state.formControls.databasePassword.touched && <FormHelperText className={classes.error}>{this.state.formControls.databasePassword.message}</FormHelperText>}
                                </FormControl>
                            </div>
                            <div className={`${classes.inputs} ${classes.middleNiagaraInputGroup}`}>
                                <FormControl className={classes.inputWrapper}>
                                    <InputLabel
                                        htmlFor="databaseName"
                                        classes={{
                                            focused: classes.cssFocused
                                        }}
                                    >
                                        {this.state.formControls.databaseName.placeholder}
                                    </InputLabel>
                                    <Input
                                        id="databaseName"
                                        name="databaseName"
                                        type="databaseName"
                                        value={this.state.formControls.databaseName.value}
                                        onChange={this.handleChange}
                                        classes={{
                                            underline: classes.cssUnderline
                                        }}
                                        inputProps={{
                                            onBlur: this.handleValidation
                                        }}
                                    />
                                    {!this.state.formControls.databaseName.valid &&
                                      this.state.formControls.databaseName.touched && <FormHelperText className={classes.error}>{this.state.formControls.databaseName.message}</FormHelperText>}
                                </FormControl>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={classes.buttonContainer}>
                    <Tooltip
                        classes={{ tooltip: classes.toolTip }}
                        title={this.showTooltipMessage(this.state.formIsValid)}
                        placement="top"
                    >
                        <div>
                            <ConfirmButton
                                confirm={this.handleSave}
                                label="Save"
                                type="button"
                                disabled={!this.state.formIsValid}
                                isLoading={isLoading}
                            />
                        </div>
                    </Tooltip>
                </div>
            </div>
        );
    }
}
